<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input v-model="query.product_name" placeholder="商品名称" class="handle-input mr10"></el-input>
        <el-select v-model="query.category_id" clearable placeholder="分类" class="handle-input mr10">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
          <el-option key="1" label="有效" value="1"></el-option>
          <el-option key="2" label="无效" value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
        <el-button type="primary" @click="handleClassify">商品分类</el-button>
      </div>
      <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column prop="ID" label="ID" width="100"></el-table-column>
        <el-table-column label="商品名称">
          <template #default="scope">
            <el-button :style="'color:#409EFF'" type="text" @click="showDetail(scope.row.ID)">
              {{ scope.row.product_name }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="封面" align="center" header-align="center" width="100">
          <template #default="scope">
            <el-image class="table-td-thumb" :src="scope.row.cover" :preview-src-list="[scope.row.cover]"
              :hide-on-click-modal="true"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="分类" show-overflow-tooltip>
          <template #default="scope">
            <el-tag v-for="(item,index) in scope.row.category" :key="index" class="mr10">{{item.category_name}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="class" label="品类" width="100"></el-table-column>
        <el-table-column prop="place" label="产地" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="能否邮寄" align="center" width="200">
          <template #default="scope">
            {{ scope.row.is_mail ? '能' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="是否有效" align="center" width="150">
          <template #default="scope">
            <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
              @click="setIsValidate(scope.$index, scope.row.ID, !scope.row.is_validate)">
              {{ scope.row.is_validate ? "有效" : "无效" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center" width="150">
          <template #default="scope">
            <el-input-number style="width: 50%;" v-model="scope.row.sort"
              @blur="setSort(scope.$index, scope.row.ID, scope.row.sort)" :precision="0" :min="0" :controls="false"
              :max="4294967295" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template #default="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
            <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.ID)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
          :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="actTitle" v-model="editVisible" width="60%">
      <el-form ref="form" :model="form" class="el-dialog__body model-h">
        <el-form-item label="商品名称" required>
          <el-input v-model="form.product_name" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="品类" required>
          <el-input v-model="form.class" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="产地" required>
          <el-input v-model="form.place" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="能否邮寄" required>
          <el-switch v-model="form.is_mail" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="显示销量" required>
          <el-input v-model="form.sales" style="margin-right: 20px;"></el-input>真实销量：<span>{{ form.true_sales }}</span>
        </el-form-item>
        <el-form-item label="商品分类" class="pl10">
          <el-select v-model="categorys" multiple placeholder="请选择" style="width: 200px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面" class="pl10">
          <!--          <el-alert title="建议尺寸750（长）*560（宽）" type="success"/>-->
          <br>
          <el-upload class="avatar-uploader" :action="action" :show-file-list="false"
            :before-upload="beforeAvatarUpload" :http-request="uploadFile">
            <img v-if="form.cover" :src="form.cover" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button type="text" @click="form.cover = ''" style="color: red">删除</el-button>
        </el-form-item>

        <el-form-item label="轮播图" class="pl10">
          <br>
          <template v-for="(item, index) in form.image_list" :key="index">
            <div style="float:left; margin: 5px;">
              <img :src="item" class="avatar">
              <el-button type="text" @click="form.image_list.splice(index, 1)" style="color: red">删除</el-button>
            </div>
          </template>
          <el-upload class="avatar-uploader upload" :action="action" :show-file-list="false"
            :before-upload="beforeAvatarUpload" :http-request="uploadAvatarFile">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <tinymce-text id="tinymce" @input="tinymcechange" @release="release"
            v-model:value="form.content"></tinymce-text>
        </el-form-item>

        <div style="padding-bottom:5px;">
          <el-button size="small" @click="addSpe">添加规格</el-button>
        </div>
        <el-table :data="speData" border style="width: 100%;">
          <el-table-column class="text_center" label="规格名称">
            <template #default="scope">
              <el-input v-model="scope.row.specs_name" style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column class="text_center" label="价格" >
            <template #default="scope">
              <el-input-number v-model="scope.row.price" :precision="2" :min="0" :controls="false" :max="4294967295"
                style="width: 100%" />
            </template>
          </el-table-column>
          <el-table-column class="text_center" label="库存">
            <template #default="scope">
              <el-input-number v-model="scope.row.stock" :precision="0" :min="0" :controls="false" :max="4294967295"
                style="width: 100%" />
            </template>
          </el-table-column>

          <el-table-column label="是否上架" align="center">
            <template #default="scope">
              <el-switch v-model="scope.row.is_sale" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template #default="scope">
              <el-button size="mini" type="danger" @click="deleteRow(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="商品分类" v-model="classifyVisible" width="70%">
      <CategoryTable></CategoryTable>
    </el-dialog>
    <!--详情弹出框-->
    <el-dialog title="商品详情" v-model="detailVisible" width="55%">
      <div class="detail_style">
        <div><img :src="detailData.cover" alt="商品封面"></div>
        <div class="row_style">
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">商品名称:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.product_name }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">所在分类:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple" prop="category_id">
                <span>{{ categoryMap.get(detailData.category_id) }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">排序:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.sort }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">价格:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.price / 100 + ' 元 ' }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">销量:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.sales }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">真实销量:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.true_sales }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">是否有效：</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.is_validate ? "有效" : "无效" }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">能否邮寄：</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.is_mail ? "能" : "否" }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">是否推荐：</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.is_recommend ? "推荐" : "不推荐" }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">创建时间：</div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple">{{ ForMatHMS(detailData.c_at) }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="list_style">
        <el-table :data="specs" style="width: 100%">
          <el-table-column prop="specs_name" label="规格" width="180">
          </el-table-column>
          <el-table-column prop="price" label="价格" width="180">
          </el-table-column>
          <el-table-column prop="stock" label="库存">
          </el-table-column>
          <el-table-column prop="is_saleName" label="是否上架">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  saveProduct,
  getProductList,
  getProduct,
  setProductIsValidate,
  getAllCategory,
  setProductSort,
  deleteProduct
} from "@/api/product";
import moment from "moment";
import TinymceText from "@/components/TinymceText";
import CategoryTable from "@/views/CategoryTable.vue"
import { dataURLtoFile, imgCompress } from '@/utils/compress.js'
import { upload } from "@/api/editor.js"

import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  components: {
    TinymceText,
    CategoryTable
  },
  name: "ProductTable",
  data() {
    return {
      action: '#',
      speData: [], //规格数组
      options: [], //商品分类
      activeName: 'local-device',
      query: {
        product_name: "",
        category_id: "",
        is_validate: null,
        page: 1,
        page_size: 10
      },
      actTitle: "添加商品",
      form: {
        is_recommend: false,
        sort: 1,
        true_sales: null,
        sales: null
      }, //提交表单数据
      tableData: [],
      pageTotal: 0,
      editVisible: false,
      file: {},
      //裁剪参数
      dialogVisible: false, // 上传图片裁切预览的弹出层是否显示
      previewImage: '', // 预览图片
      cropper: null, // 裁切器实例
      fileName: '', // 文件名称
      updatePhotoLoading: false, // 是否正在更新用户头像 loading显示与否
      classifyVisible: false,
      detailVisible: false,
      detailData: {},
      categoryMap: new Map(),
      categorys:[]
    }
  },
  created() {
    this.init()
  },
  computed: {
    specs() {
      let newSpecs = []
      newSpecs = this.detailData.specs_list || []
      newSpecs.forEach(item => {
        item.c_at = this.ForMatHMS(item.c_at)
        item.price = item.price / 100 + ' 元 '
        if (item.is_sale) {
          item.is_saleName = '已上架'
        } else {
          item.is_saleName = '已下架'
        }
      })
      return newSpecs
    }
  },
  methods: {
    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    tinymcechange(content) {
      this.form.content = content
      // this.$emit("tinymcechange", e);
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    init() {
      this.getAllCate();
      this.getData();
    },
    handleClick(tab) {
      if (this.$refs[tab.paneName]) {
        this.$nextTick(() => {
          this.$refs[tab.paneName].init()
        })
      }
    },
    // 商品分类
    handleClassify() {
      this.classifyVisible = true
    },
    // 搜索商品
    getData() {
      getProductList(this.query).then(res => {
        let newOptions = JSON.parse(JSON.stringify(this.options))
        let op = []
        for (const k in newOptions) {
          op[newOptions[k].value] = newOptions[k].label
        }
        for (const k in res.data) {
          res.data[k].cate_name = "无"
          if (op[res.data[k].category_id] !== undefined) {
            res.data[k].cate_name = op[res.data[k].category_id]
          }
        }
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }

      })
    },
    // 搜索商品
    getAllCate() {
      this.options = []
      getAllCategory().then(res => {
        res.forEach(function (val) {
          this.options.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },
    save(row) {
      saveProduct(row.ID, row).then(res => {
        if (res) {
          this.$message.success('保存成功')
        }
        this.getData()
      })
    },

    // 删除操作
    handleDelete(id) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteProduct(id).then(res => {
          if (res === true) {
            this.$message.success("删除成功")
            this.getData()
          }
        })
      }).catch(() => {
      });
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    handleEdit(index, row) {
      this.idx = index;
      this.getAllCate();
      getProduct(row.ID).then(res => {
        this.actTitle = "编辑商品"
        this.form = res
        this.form.id = row.ID
        this.categorys = []
        res.category.forEach(item => {
          this.categorys.push(item.ID)
        })
        let specs_list = JSON.parse(JSON.stringify(res.specs))
        if (specs_list !== undefined) {
          for (const k in specs_list) {
            specs_list[k].price = specs_list[k].price / 100
          }
        }
        this.speData = specs_list

      }).then(
        this.editVisible = true
      )
    },

    // 添加操作
    handleAdd() {
      this.speData = []
      this.form = {}
      this.form.id = 0
      this.editVisible = true
      this.form.sort = 1
      this.form.is_recommend = false
    },

    saveEdit() {
      console.log(this.categorys)
      this.form.category = []
      this.categorys.forEach(item => {
        this.form.category.push({id:item})
      })
      let paramData = Object.assign({}, this.form)
      paramData.sales = Number(paramData.sales)

      //处理规格
      let specs_list = JSON.parse(JSON.stringify(this.speData))
      let price = 0
      //处理规格
      if (specs_list.length == 0) {
        this.$message.error("请添加规格")
        return
      }
      if (specs_list !== undefined) {
        for (const k in specs_list) {
          specs_list[k].price = specs_list[k].price * 100
          if (specs_list[k].price == 0) {
            this.$message.error("规格价格不能为0")
            return
          }
          if (price == 0 || price > specs_list[k].price) {
            price = specs_list[k].price
          }
        }
      }
      paramData.specs = specs_list
      paramData.price = price
      saveProduct(this.form.id, paramData).then(res => {
        if (res === true) {
          this.$message.success("保存成功")
          this.getData()
          this.editVisible = false
        }
      })
    },

    setIsValidate(index, id, isvalidate) {
      setProductIsValidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },
    setSort(index, id, sort) {
      setProductSort(id, sort).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].sort = sort
        }
      })
    },
    addSpe() {
      let data = {
        id: 0,
        specs_name: '',
        price: 0,
        stock: 0,
        is_sale: true
      }
      this.speData.push(data)
    },
    deleteRow(index) {
      this.speData.splice(index, 1)
    },

    async beforeAvatarUpload(file) {
      file = await imgCompress(file)
      this.file = file
      file = file.file
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    uploadFile() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append("file", this.file.file);
      upload(formData).then(res => {
        if (res.url === undefined) {
          this.file = {}
        }
        this.form.cover = res.url
        this.file = {}
        loading.close();
      })
    },
    uploadAvatarFile() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let formData = new FormData();
      formData.append("file", this.file.file);
      upload(formData).then(res => {
        if (res.url === undefined) {
          this.file = {}
        }
        let that = this
        let image_list = that.form.image_list

        if (image_list === undefined) {
          image_list = []
        }
        image_list.push(res.url)
        that.form.image_list = image_list
        this.file = {}
        loading.close();
      })
    },
    onFileChange() {
      // 处理图片预览
      const file = this.$refs.file
      this.fileName = file.name
      const blobData = window.URL.createObjectURL(file.files[0])
      this.previewImage = blobData
      // 展示弹出层，预览用户选择的图片
      this.dialogVisible = true
      // 解决选择相同图片不触发change事件的问题
      this.$refs.file.value = ''
    },

    // 对话框完全打开后
    onDialogOpened() {
      // 图片裁切器必须基于image初始化
      // 注意：image必须是可见状态才能正常进行初始化
      // 获取图片DOM节点
      const image = this.$refs['preview-image']
      // 第1次初始化好裁切器以后，如果预览裁切的图片发生变化，裁切器默认不会更新图片
      // 如果需要预览图片发送变化，更新裁切器：
      //    方式一：裁切器.replace()
      //    方式二：销毁裁切器，重新初始化
      // 初始化裁切器
      // if (this.cropper) {
      //   this.cropper.replace(this.previewImage)
      // }
      const cropper = new Cropper(image, {
        aspectRatio: 1 / 1,
        viewMode: 1,
        dragMode: 'none',
        background: true,
        cropBoxResizable: true,
        // 当你移动裁切器的时候会触发crop方法的调用
      })
      this.cropper = cropper
    },
    onDialogClosed() {
      // this.cropper = null
      this.previewImage = ''
      this.fileName = ''
      this.cropper.destroy()
    },
    onUpdatePhoto() {
      let img = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      // eslint-disable-next-line no-unused-vars
      let newImg = dataURLtoFile(img, this.fileName)
    },
    //   展示详情
    showDetail(id) {
      getProduct(id).then(res => {
        let that = this
        this.options.forEach(function (item) {
          that.categoryMap.set(item.value, item.label)
        })
        this.detailData = res
        this.detailVisible = true
      })
    }

  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.el-input {
  width: 150px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.upload {
  float: left;
  margin: 5px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}


.model-h {
  height: 20%;
}

.is-tabs_item .is-active {
  border-bottom: none;
}

.pl10 {
  padding-left: 5px;
}

/*.pr10{*/
/*  padding-right: 10px;*/
/*}*/
.detail_style {
  padding-left: 5%;
  display: flex;
}

.detail_style img {
  width: 300px;
  margin-right: 20px;
  flex: 1;
}

.row_style {
  flex: 1;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.fw900 {
  font-weight: 900;
}

.list_style {
  margin-top: 30px;
  text-align: center;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
  padding: 0;
}

.el-input-number {
  width: 150px;
  margin: 0 auto;
}

.text_center {
  text-align: center;
}

/deep/.el-tabs__item {
  width: 100px;
  text-align: center;
}
</style>
